module.exports = __webpack_public_path__ + "static/media/img7.b964ad25.jpeg";